import styled from "styled-components";

export const Client_photoProfile =  styled.div`
height: auto;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
  
`;
export const ClientContainer = styled.div`
background-color:  rgba(147, 153, 156, 0.3)  ;
pading : 100px;
    width: auto;
    margin: 10%;
    height: auto;
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    border-radius: 10px;
    padding: 30px;
    box-shadow: rgb(0 0 0 / 17%) 0px 2px 5px 0px;
`;
export const div_body = styled.body`
background-color: #0d89c6;
`;

